import type { WagerSettings } from '../../../../schema/sessionstore/entry.js';
import {
  BadRequestError,
  type ISessionStoreRepository,
  type IUpdateWagerSettingsUseCase,
} from '../../../domain/entry.js';

/**
 * Use case for updating wager settings.
 *
 * @param wagerSettingsRepository Session store repository dependency
 * @returns Use case executor for updating wager settings
 */
export function updateWagerSettingsUseCase(
  wagerSettingsRepository: ISessionStoreRepository
): IUpdateWagerSettingsUseCase {
  return {
    execute: async ({ product, payload, settingsKey }): ReturnType<IUpdateWagerSettingsUseCase['execute']> => {
      if (payload.correction.includes('Defined') || payload.correction.includes('Opened')) {
        throw new BadRequestError('Invalid correction settings: Cannot include "Defined" or "Opened" states.');
      }

      const nextWagerSettings = {
        correction: payload.correction,
      } satisfies WagerSettings;

      return wagerSettingsRepository.updateWagerSettingsAsync(
        product,
        nextWagerSettings satisfies WagerSettings,
        settingsKey
      );
    },
  };
}
